import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService, OrderLineAgent, SalesOrderLine, TmsWebBaseEditCreateService } from 'tms-lib';
import { SalesAgentsCommissionDetails } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class OrderLineAgentService extends TmsWebBaseEditCreateService<SalesOrderLine, OrderLineAgent> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('OrderLineAgent', $localize`Order Line Agent`, httpService, notificationService);
  }

  getForSalesOrderLine(id: string): Observable<OrderLineAgent[]> {
    return this.httpService.get<OrderLineAgent[]>(`${this.apiUrl}/GetForSalesOrderLine?id=${id}`);
  }

  getSalesAgentsCommission(fromDate: Date, toDate: Date): Observable<SalesAgentsCommissionDetails[]> {
    return this.httpService.get<SalesAgentsCommissionDetails[]>(
      `${this.apiUrl}/SalesAgentsCommission?fromDate=${fromDate.toISOString()}&toDate=${toDate.toISOString()}`,
    );
  }
}
